module.exports = __webpack_public_path__ + "img/project9_20.png.4df41f73.webp";